import { render } from "./TopUser.vue?vue&type=template&id=54c84a43&scoped=true"
import script from "./TopUser.vue?vue&type=script&lang=js"
export * from "./TopUser.vue?vue&type=script&lang=js"

import "./TopUser.vue?vue&type=style&index=0&id=54c84a43&scoped=true&lang=css"

import exportComponent from "/Users/beerebeerey/github-classroom/MUICCS/cs340prj-beersilver/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54c84a43"]])

export default __exports__